export const VERSION_APP = '1.1.2';
export const ENV = {
    DEV: {
        API_BASE_URL: 'https://deaf-via-setting-mitsubishi.trycloudflare.com',
        LIFF_ID: '2010267661-M1CmfIpu',
    },
     PROD: {
        API_BASE_URL: 'https://azure-ram-709240.hostingersite.com',
        LIFF_ID: '2005468534-PvubEwqh',
    }
}

export const CURRENT_ENV = ENV.PROD;
